import { render, staticRenderFns } from "./Sucesiones.vue?vue&type=template&id=3081169e&"
import script from "./Sucesiones.vue?vue&type=script&lang=js&"
export * from "./Sucesiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports